/**
 * The entry rotunda: a domed drum with an oculus, the heart the whole route
 * grows from. Also the exemplar for circular rooms built with drumWithDoors.
 */

import { PALACE } from '../constants';

const rotunda = {
  id: 'rotunda',
  role: 'entry',
  weight: 1,

  plan() {
    const size = 2 * PALACE.ROTUNDA_R + 2.4;
    return { w: size, d: size, height: PALACE.WALL_H };
  },

  segments() {
    return [];
  },

  build(node, T) {
    const { ROTUNDA_R, WALL_H } = T.PALACE;
    const cx = (node.x1 + node.x2) / 2;
    const cz = (node.z1 + node.z2) / 2;
    const group = new T.THREE.Group();

    const { curvedGeos, boxGeos, colliders } = T.drumWithDoors(node, ROTUNDA_R, WALL_H);
    group.add(T.mergedMesh(curvedGeos, T.kit.materials.dome));
    if (boxGeos.length) group.add(T.mergedMesh(boxGeos, T.kit.materials.dome));

    const floor = new T.THREE.Mesh(
      new T.THREE.CircleGeometry(ROTUNDA_R + 2, 48),
      T.kit.materials.marble
    );
    floor.rotation.x = -Math.PI / 2;
    floor.position.set(cx, 0, cz);
    floor.matrixAutoUpdate = false;
    floor.updateMatrix();

    const dome = new T.THREE.Mesh(
      new T.THREE.SphereGeometry(ROTUNDA_R, 48, 24, 0, Math.PI * 2, 0, Math.PI / 2),
      T.kit.materials.dome
    );
    dome.position.set(cx, WALL_H, cz);
    dome.matrixAutoUpdate = false;
    dome.updateMatrix();

    const oculus = new T.THREE.Mesh(new T.THREE.CircleGeometry(1.8, 32), T.kit.materials.laylight);
    oculus.rotation.x = Math.PI / 2;
    oculus.position.set(cx, WALL_H + ROTUNDA_R - 0.25, cz);
    oculus.matrixAutoUpdate = false;
    oculus.updateMatrix();

    const light = new T.THREE.PointLight(0xfff0d8, 40, ROTUNDA_R * 4, 1.8);
    light.position.set(cx, WALL_H + 2, cz);

    group.add(floor, dome, oculus, light);
    return { group, colliders };
  },
};

export default rotunda;
